module.exports = __webpack_public_path__ + "static/media/background-exp.091bd580.webp";